import { Button, Grid, Typography } from "@mui/material"
import PixSimulation from "../../../../../../assets/img/modalities/04-simulation.png"
import { useEffect, useRef, useState } from "react"
import { ModalSimulator } from "../modal/simulator"
import useAuth from "../../../../../../context/auth"
import { ModalReferAndWin } from "../modal/referAndWin"
import moment from "moment"
import { Constants } from "../../../../../../utils"

export const Modalities = ({ openModalBusinessActivity }: { openModalBusinessActivity: () => void }) => {
    const { user } = useAuth()

    const containerRef = useRef<HTMLDivElement>(null)
    const [scrollPosition, setScrollPosition] = useState(0)

    const [containerWidth, setContainerWidth] = useState(0)
    const [scrollWidth, setScrollWidth] = useState(0)

    const [openSimulator, setOpenSimulator] = useState(false)
    const [openReferAndWin, setOpenReferAndWin] = useState(false)
    const blocked = (user?.client?.blockedReason ?? [])
        .sort((a, b) => new Date(b.at).getTime() - new Date(a.at).getTime())
        .find((item) => item.action === "dont_can_start_new_contract")?.message

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.clientWidth)
            setScrollWidth(containerRef.current.scrollWidth)

            // Evento de scroll para atualizar a posição do scroll
            const handleScroll = () => {
                setScrollPosition(containerRef.current?.scrollLeft || 0)
            }

            containerRef.current.addEventListener("scroll", handleScroll)

            // Limpar o evento quando o componente for desmontado
            return () => {
                containerRef.current?.removeEventListener("scroll", handleScroll)
            }
        }
    }, [])

    useEffect(() => {
        // Calcular a largura do box após a renderização inicial
        if (containerWidth && scrollWidth) {
            setContainerWidth(containerRef.current?.clientWidth || 0)
            setScrollWidth(containerRef.current?.scrollWidth || 0)
        }
    }, [containerWidth, scrollWidth])

    return (
        <Grid
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative"
            }}>
            <Grid
                ref={containerRef}
                sx={{
                    width: "100%",
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "center",
                    gap: "2rem",
                    // "& button": {
                    //     backgroundColor: "transparent",
                    //     border: "none",
                    //     cursor: "pointer"
                    // },
                    // "& button:first-of-type img": {
                    //     width: "8.992rem",
                    //     height: "12.751rem"
                    // },
                    // "& button img": {
                    //     width: "7rem",
                    //     height: "10.041rem"
                    // },
                    // "&::-webkit-scrollbar": {
                    //     display: "none", // Remove o scrollbar visualmente
                    // },
                    // "&": {
                    //     scrollbarWidth: "none",  // Para navegadores Firefox
                    // }
                }}
            >
                {/* <button onClick={() => {
                    if (user?.client?.actualTable === 0 || moment(user?.client?.canRequestAfter).diff(moment(), "days") > 0) {
                        setOpenReferAndWin(true)
                    } else {
                        setOpenSimulator(true)
                    }
                }}>
                    <img src={PixSimulation} alt="Alugar PIX" draggable={false} style={{
                        animation: "pulse 2s infinite"
                    }}/>
                </button> */}
                <Button
                    variant="contained"
                    sx={{
                        width: "26.7rem",
                        height: "4.9rem",
                        display: "flex",
                        flexDirection: "column",
                        zIndex: 2,
                        animation: "pulse 2s infinite"

                    }}
                    onClick={() => {
                        if (moment(user?.client?.lastUpdate).isBefore(Constants.activityDeployedAt) && openModalBusinessActivity) {
                            openModalBusinessActivity()
                        } else if (blocked || user?.client?.actualTable === 0 || moment(user?.client?.canRequestAfter).diff(moment(), "days") > 0) {
                            setOpenReferAndWin(true)
                        } else {
                            setOpenSimulator(true)
                        }
                    }}
                >
                    <Typography sx={{
                        fontSize: "1.4rem",
                        fontWeight: "500",
                    }}>
                        Solicite Seu <u><strong>Crédito</strong></u> Aqui!
                    </Typography>
                </Button>
                {/* <button>
                    <img src={Car} alt="Alugar CARRO" draggable={false} />
                </button>
                <button>
                    <img src={Motorcycle} alt="Alugar MOTO" draggable={false} />
                </button>
                <button>
                    <img src={Cellphone} alt="Alugar CELULAR" draggable={false} />
                </button> */}
            </Grid>

            {/* <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: 2
                }}>

                <Box
                    sx={{
                        width: "9.5rem",
                        height: "5px",
                        backgroundColor: "#DDDFFF",
                        position: "relative",
                        borderRadius: "4rem",
                    }}
                >
                    <Box
                        sx={{
                            width: `${(containerWidth / scrollWidth) * 100}%`, // Largura proporcional
                            borderRadius: "4rem",
                            height: "100%", // Ajuste a altura conforme necessário
                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                            position: "absolute",
                            left: `${(scrollPosition / scrollWidth) * 100}%`, // Posição proporcional
                        }}
                    />
                </Box>
            </Grid> */}
            <ModalSimulator open={openSimulator} onClose={() => setOpenSimulator(false)} />
            <ModalReferAndWin open={openReferAndWin} reason={blocked} onClose={() => setOpenReferAndWin(false)} />

        </Grid>
    )
}